import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CentreCard } from "@/components/asv/CentreCard";
import { Empty } from "@/components/asv/Cards";

const SORTS = [["name", "A to Z"], ["rating", "Top rated"], ["venues", "Most venues"]];

const Select = ({ value, onChange, options, all, testid }) => (
  <select className="asv-input" style={{ width: "auto", minWidth: 150 }} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
    {all && <option value="">{all}</option>}{options.map((o) => Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>)}
  </select>
);

export default function AsvCentres() {
  const [sp, setSp] = useSearchParams();
  const [d, setD] = useState(null);
  const f = { q: sp.get("q") || "", sport: sp.get("sport") || "", state: sp.get("state") || "", sort: sp.get("sort") || "name" };
  useEffect(() => { api.get("/asv/centres", { params: f }).then((r) => setD(r.data)).catch(() => setD({ items: [], sports: [], states: [] })); }, [sp.toString()]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k, v) => setSp(Object.fromEntries(Object.entries({ ...f, [k]: v }).filter(([key, x]) => x && !(key === "sort" && x === "name"))));
  const active = f.q || f.sport || f.state;
  return (
    <div className="pt-10" data-testid="asv-centres">
      <h1 className="asv-display text-4xl font-extrabold sm:text-5xl">Sport Centres</h1>
      <p className="asv-muted mt-2 text-sm sm:text-base">Every venue owner on All Sports Venues, in one place.</p>
      <div className="mt-6 flex flex-wrap items-center gap-3">
        <input className="asv-input" style={{ maxWidth: 380, flex: "1 1 220px" }} placeholder="Search sport centres" defaultValue={f.q} key={f.q}
          onKeyDown={(e) => e.key === "Enter" && set("q", e.target.value.trim())} data-testid="centres-search" />
        <Select value={f.sport} onChange={(v) => set("sport", v)} options={d?.sports || []} all="All sports" testid="centres-sport" />
        <Select value={f.state} onChange={(v) => set("state", v)} options={d?.states || []} all="All states" testid="centres-state" />
        <Select value={f.sort} onChange={(v) => set("sort", v)} options={SORTS} testid="centres-sort" />
        {active && <button type="button" className="asv-muted text-sm font-semibold underline" onClick={() => setSp({})} data-testid="centres-clear">Clear filters</button>}
      </div>
      {d && <p className="asv-muted mt-4 text-sm" data-testid="centres-total">{d.total} sport centre{d.total === 1 ? "" : "s"}</p>}
      <div className="mt-4">
        {!d ? <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">{[1, 2, 3, 4].map((i) => <div key={i} className="asv-card h-72 animate-pulse" />)}</div>
          : d.items.length ? <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="centres-results">{d.items.map((c) => <CentreCard key={c.slug} c={c} row />)}</div>
            : <Empty text="No sport centres match these filters yet." />}
      </div>
    </div>
  );
}
